import axios from 'axios';
import { configs } from '../app/app-configs';
import { BusinessUser, BusinessUserRequest } from './model/user.model';
import { Member, MemberRequest } from './model/member.model';

export const getUsers = async (): Promise<BusinessUser[]> => {
    return await axios.get(`${configs.BASE_URL}/user`).then((res) => {
        return res.data as BusinessUser[];
    });
};

export const createUser = async (
    request: BusinessUserRequest,
): Promise<BusinessUser> => {
    return await axios.post(`${configs.BASE_URL}/user`, request).then((res) => {
        return res.data as BusinessUser;
    });
};

export const updateUser = async (
    request: BusinessUserRequest,
): Promise<BusinessUser> => {
    return await axios
        .put(`${configs.BASE_URL}/user/${request.id}`, request)
        .then((res) => {
            return res.data as BusinessUser;
        });
};

export const deleteUser = async (id: number): Promise<number> => {
    return await axios.delete(`${configs.BASE_URL}/user/${id}`).then((res) => {
        return res.data;
    });
};

export const updateBusinessUserProfile = async (
    request: BusinessUserRequest,
): Promise<BusinessUser> => {
    return await axios
        .put(`${configs.BASE_URL}/user/profile/business-user/${request.id}`, request)
        .then((res) => {
            return res.data as BusinessUser;
        });
};

export const updateMemberUserProfile = async (request: MemberRequest): Promise<Member> => {
    return await axios.put(`${configs.BASE_URL}/user/profile/member/${request.id}`, request)
    .then(res => {
        return res.data as Member;
    });
}
